
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CreditCard, Star } from 'lucide-react';

interface CreditBalanceDisplayProps {
  balance: number;
  isMember: boolean;
}

const CreditBalanceDisplay = ({ balance, isMember }: CreditBalanceDisplayProps) => {
  return (
    <Card className="border-juv-rose-clay/20 bg-gradient-to-r from-juv-terracotta to-juv-deep-chestnut text-white">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center space-x-2">
            <CreditCard className="h-5 w-5" />
            <span>JUV Credits</span>
          </CardTitle>
          {isMember && (
            <Badge className="bg-white/20 text-white">
              <Star className="h-3 w-3 mr-1" />
              Member
            </Badge>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="text-3xl font-bold">{balance}</div>
          <div className="text-white/80 text-sm">
            Credits Available • ${(balance * 50).toLocaleString()} Value
          </div>
          {balance < 5 && (
            <div className="text-juv-rose-clay-light text-sm font-medium">
              ⚠️ Low credit balance - consider purchasing more
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default CreditBalanceDisplay;
